export default __webpack_public_path__ + "3c1b5a5d5d602fcff442198b90701741.png";